import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CartModel } from './cart.model';

export const selectCartState = createFeatureSelector<CartModel>('cart');

export const selectCartData = createSelector(
  selectCartState,
  (state: CartModel) => state.CartData
);

export const selectCartProducts = createSelector(
  selectCartData,
  (cartData) => cartData.products
);

export const selectCartTotal = createSelector(
  selectCartData,
  (cartData) => cartData.total
);
export const selectCartSubtotal = createSelector(
  selectCartData,
  (cartData) => {
    if (!cartData || !cartData.products || cartData.products.length === 0) {
      return 0;
    }

    return cartData.products.reduce((sum, product) => sum + product.subtotal, 0);
  }
);

export const selectCartId = createSelector(
  selectCartData,
  (cartData) => cartData.cart_id
);

export const selectEstablishmentId = createSelector(
  selectCartData,
  (cartData) => cartData.establishment_id
);
export const selectEstablishmentName = createSelector(
  selectCartData,
  (cartData) => cartData.establishment_name
);


export const selectShoppingCartId=createSelector(
  selectCartData,
  (cartData) => cartData.cart_id
)

export const selectIsCartEmpty = createSelector(
  selectCartProducts,
  (products) => !products || products.length === 0
);
